module.exports = __webpack_public_path__ + "static/media/halfv1.830b57ff.png";